// extracted by css-extract-rspack-plugin
export default {"qualityButton":"qualityLevels-styles-qualityButton-4a957f8d","qualityButtonContainer":"qualityLevels-styles-qualityButtonContainer-9333bdc2"};